/* ==========================================================================
   LUNÉA — Complete je routine
   · <lunea-routine>       blok op de productpagina (snippets/lunea-routine.liquid)
   · <lunea-routine-cart>  strip in de winkelwagenlade (snippets/lunea-routine-cart.liquid)

   Koppeling met het thema (Gecko, geen Dawn):
   · koopknop = formulier #lunea-product-form. Het inline script van
     sections/lunea-product.liquid stuurt het naar window.LuneaATC.submit(form)
     (assets/lunea-product-cart.js). Dat stuurt na afloop lunea:cart:added of
     lunea:cart:error, met { form, variantId }.
   · lade verversen = window.LuneaATC.refresh() (→ theme.miniCart.generateCart()).
   · de lade zelf is geen sectie; de strip wel: /?sections=lunea-routine-cart.

   Koopflow met aangevinkt vakje:
   1. submit onderscheppen in de capture-fase (vóór het script van de sectie);
   2. eerst het extra item via /cart/add.js;
   3. dan het formulier opnieuw laten versturen met een pass-vlag, zodat de
      gewone add-to-cart van het thema doorloopt en de lade beide toont;
   4. mislukt het hoofdproduct (lunea:cart:error), dan het extra item terugzetten
      (aantal −1 via de line key).
   Zolang dat loopt, wordt elke nieuwe submit van dat formulier tegengehouden:
   een dubbelklik voegt niets dubbel toe.

   "Kopen met Shop"/"Nu kopen" (dynamische checkout) verstuurt het formulier niet
   en zou het aangevinkte extra item dus overslaan. Zolang het vakje aan staat,
   krijgt het formulier data-lu-routine-on en verbergt de CSS die knop.
   ========================================================================== */
(function () {
  'use strict';

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function postJSON(path, body) {
    return fetch(root() + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) {
        if (!r.ok || (j && j.status && Number(j.status) >= 400)) {
          var err = new Error((j && (j.description || j.message)) || '');
          err.status = r.status;
          throw err;
        }
        return j;
      });
    });
  }

  /* Melding buiten beeld (bv. na de sticky koopbalk) in beeld brengen. */
  function reveal(el) {
    var r = el.getBoundingClientRect();
    if (r.top >= 0 && r.bottom <= (window.innerHeight || document.documentElement.clientHeight)) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    el.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
  }

  /* Zelfde test als lunea-product-cart.js: op /cart is er geen lade. */
  function isCartPage() {
    if (window.theme && typeof window.theme.cartpage === 'boolean') return window.theme.cartpage;
    return /\/cart\/?$/.test(location.pathname);
  }

  function refreshDrawer() {
    if (window.LuneaATC && typeof window.LuneaATC.refresh === 'function') {
      return window.LuneaATC.refresh();
    }
    if (window.theme && window.theme.miniCart) {
      window.theme.miniCart.updateElements();
      window.theme.miniCart.generateCart();
    }
    return Promise.resolve();
  }

  /* ------------------------------------------------------------------------
     1. Productpagina
     ---------------------------------------------------------------------- */
  if (!customElements.get('lunea-routine')) {
    customElements.define('lunea-routine', class extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        var source = this.querySelector('[data-routine-json]');
        try { this.data = JSON.parse(source.textContent); } catch (e) { return; }
        this._ready = true;
        this.items = this.data.items || [];
        this.index = 0;
        this.variantId = null;
        this.busy = false;
        this.toggle = this.querySelector('[data-routine-toggle]');
        this.errorEl = this.querySelector('[data-routine-error]');

        // Nooit vooraf aangevinkt, ook niet als de browser het formulier herstelt.
        // Het vakje staat in de HTML uitgeschakeld tot dit script het overneemt.
        this.toggle.checked = false;
        this.toggle.disabled = false;

        this.onClick = this.onClick.bind(this);
        this.onToggle = this.onToggle.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.onPageShow = this.onPageShow.bind(this);
        this.onMainChange = this.onMainChange.bind(this);

        this.addEventListener('click', this.onClick);
        this.toggle.addEventListener('change', this.onToggle);
        document.addEventListener('submit', this.onSubmit, true);
        window.addEventListener('pageshow', this.onPageShow);
        this.scope = this.closest('.shopify-section') || document;
        this.scope.addEventListener('change', this.onMainChange);

        this.syncSingleVariant();
        this.renderState();
      }

      disconnectedCallback() {
        if (!this._ready) return;
        this.removeEventListener('click', this.onClick);
        this.toggle.removeEventListener('change', this.onToggle);
        document.removeEventListener('submit', this.onSubmit, true);
        window.removeEventListener('pageshow', this.onPageShow);
        this.scope.removeEventListener('change', this.onMainChange);
        var form = this.form();
        if (form) form.removeAttribute('data-lu-routine-on');
        this._ready = false;
      }

      get item() { return this.items[this.index]; }

      form() { return document.getElementById(this.dataset.formId); }

      mainVariantId() {
        var form = this.form();
        var input = form ? form.querySelector('[name="id"]') : null;
        return input ? String(input.value) : String(this.data.current || '');
      }

      /* De gekozen variant van de suggestie, anders de standaardvariant (voor de prijzen). */
      activeVariant() {
        var item = this.item;
        if (!item) return null;
        var id = this.variantId || String(item.defaultVariant || '');
        for (var i = 0; i < item.variants.length; i++) {
          if (String(item.variants[i].id) === id) return item.variants[i];
        }
        return item.variants[0] || null;
      }

      syncSingleVariant() {
        var item = this.item;
        if (item && item.variants.length === 1 && item.variants[0].available) {
          this.variantId = String(item.variants[0].id);
        }
      }

      onPageShow(event) {
        // Terugknop (bfcache): de pagina komt terug zoals ze was, vakje incluis.
        if (event.persisted) this.reset();
      }

      onClick(event) {
        var variant = event.target.closest('[data-routine-variants] [data-variant-id]');
        if (variant) {
          if (!variant.disabled) this.selectVariant(variant.getAttribute('data-variant-id'));
          return;
        }
        var thumb = event.target.closest('[data-routine-thumb]');
        if (thumb) this.selectItem(Number(thumb.getAttribute('data-routine-thumb')));
      }

      /* Een variant kiezen is een bewuste keuze: dan mag het vakje aan. */
      selectVariant(variantId) {
        this.variantId = String(variantId);
        this.querySelectorAll('[data-routine-variants] [data-variant-id]').forEach(function (button) {
          button.setAttribute('aria-pressed', button.getAttribute('data-variant-id') === String(variantId) ? 'true' : 'false');
        });
        this.toggle.checked = true;
        this.hideError();
        this.renderState();
      }

      selectItem(index) {
        var item = this.items[index];
        if (!item || index === this.index) return;
        this.index = index;
        this.variantId = null;
        this.toggle.checked = false;
        this.hideError();
        this.querySelectorAll('[data-routine-thumb]').forEach(function (thumb) {
          thumb.setAttribute('aria-pressed', Number(thumb.getAttribute('data-routine-thumb')) === index ? 'true' : 'false');
        });
        this.querySelectorAll('[data-routine-link]').forEach(function (link) { link.href = item.url; });
        var title = this.querySelector('[data-routine-title]');
        if (title) title.textContent = item.title;
        this.renderImage(item);
        this.renderVariants(item);
        this.syncSingleVariant();
        this.renderState();
      }

      renderImage(item) {
        var media = this.querySelector('.lu-routine__media');
        var image = this.querySelector('[data-routine-image]');
        if (!item.image) { if (image) image.hidden = true; return; }
        if (!image && media) {
          image = document.createElement('img');
          image.setAttribute('data-routine-image', '');
          image.alt = '';
          image.width = 72;
          image.height = 72;
          media.appendChild(image);
        }
        if (image) { image.hidden = false; image.src = item.image; }
      }

      renderVariants(item) {
        var wrap = this.querySelector('[data-routine-variants-wrap]');
        var list = this.querySelector('[data-routine-variants]');
        var label = this.querySelector('[data-routine-variant-label]');
        if (!wrap || !list) return;
        list.innerHTML = '';
        if (item.variants.length > 1) {
          item.variants.forEach(function (variant) {
            var button = document.createElement('button');
            button.type = 'button';
            button.className = 'lu-routine__variant';
            button.setAttribute('data-variant-id', variant.id);
            button.setAttribute('aria-pressed', 'false');
            button.textContent = variant.title;
            button.disabled = !variant.available;
            list.appendChild(button);
          });
        }
        if (label) label.textContent = item.optionName || '';
        wrap.hidden = item.variants.length <= 1;
      }

      /* Setprijs bij de huidige variant van het hoofdproduct en de gekozen (of standaard)
         variant van de suggestie. Voorberekend in Liquid: sets[hoofdvariant][suggestievariant]. */
      currentSet() {
        var item = this.item;
        var variant = this.activeVariant();
        if (!item || !item.sets || !variant) return null;
        var byMain = item.sets[this.mainVariantId()];
        if (!byMain) return null;
        return byMain[String(variant.id)] || null;
      }

      renderState() {
        var item = this.item;
        if (!item) return;
        this.classList.toggle('is-selected', this.toggle.checked);
        var form = this.form();
        if (form) {
          if (this.toggle.checked) form.setAttribute('data-lu-routine-on', '');
          else form.removeAttribute('data-lu-routine-on');
        }
        var variant = this.activeVariant();
        var price = (variant && variant.price) || item.price;
        var priceEl = this.querySelector('[data-routine-price]');
        if (priceEl) priceEl.textContent = price;
        var addPrice = this.querySelector('[data-routine-add-price]');
        if (addPrice) addPrice.textContent = '+ ' + price;

        var set = this.currentSet();
        var badge = this.querySelector('[data-routine-badge]');
        if (badge) {
          badge.hidden = !set;
          if (set) badge.textContent = (this.data.strings.save || '').replace('[amount]', set.save);
        }
        var box = this.querySelector('[data-routine-set]');
        if (box) {
          box.hidden = !set;
          if (set) {
            box.querySelector('[data-routine-set-was]').textContent = set.was;
            box.querySelector('[data-routine-set-now]').textContent = set.now;
          }
        }
      }

      onToggle() {
        if (this.toggle.checked && !this.variantId) this.showError(this.data.strings.chooseVariant);
        else this.hideError();
        this.renderState();
      }

      /* Variantwissel van het hoofdproduct: het script van de sectie heeft het
         verborgen id-veld dan al bijgewerkt (dat luistert op de radio zelf). */
      onMainChange(event) {
        if (!event.target.closest || !event.target.closest('[data-lu-option-input]')) return;
        this.renderState();
      }

      onSubmit(event) {
        var form = event.target;
        if (!form || !form.getAttribute || form.getAttribute('id') !== this.dataset.formId) return;
        if (form.hasAttribute('data-lu-routine-pass')) return;
        if (this.busy) {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        if (!this.toggle.checked) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        if (!this.variantId) {
          this.showError(this.data.strings.chooseVariant);
          this.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
        this.addThenContinue(form);
      }

      addThenContinue(form) {
        var self = this;
        var button = form.querySelector('[type="submit"]');
        var mainInput = form.querySelector('[name="id"]');
        var mainVariantId = mainInput ? String(mainInput.value) : '';
        this.setBusy(true, button);

        postJSON('cart/add.js', { items: [{ id: Number(this.variantId), quantity: 1 }] })
          .then(function (parsed) {
            var line = parsed && parsed.items ? parsed.items[0] : null;
            self.reset();
            self.watchMainAdd(form, line, mainVariantId);
            if (button) { button.classList.remove('is-loading'); button.disabled = false; }
            form.setAttribute('data-lu-routine-pass', '');
            try {
              if (typeof form.requestSubmit === 'function') form.requestSubmit();
              else form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
            } finally {
              form.removeAttribute('data-lu-routine-pass');
            }
          })
          .catch(function (error) {
            self.setBusy(false, button);
            // Uitleg van Shopify alleen bij een HTTP-fout; geen "Failed to fetch" in beeld
            self.showError((error && error.status && error.message) || self.data.strings.error);
            reveal(self.errorEl || self);
          });
      }

      /* Blijft bezet tot het hoofdproduct toegevoegd is of mislukt (max. 20 s). */
      watchMainAdd(form, line, mainVariantId) {
        var self = this;
        var done = false;
        var timer;
        function mine(event) {
          var d = (event && event.detail) || {};
          if (d.form) return d.form === form;
          return !!mainVariantId && String(d.variantId) === mainVariantId;
        }
        function stop() {
          if (done) return;
          done = true;
          document.removeEventListener('lunea:cart:added', onAdded);
          document.removeEventListener('lunea:cart:error', onError);
          clearTimeout(timer);
          self.setBusy(false);
        }
        function onAdded(event) { if (mine(event)) stop(); }
        function onError(event) {
          if (!mine(event)) return;
          stop();
          if (!line || !line.key) return;
          postJSON('cart/change.js', { id: line.key, quantity: Math.max(0, (line.quantity || 1) - 1) })
            .then(refreshDrawer)
            .catch(function () {});
        }
        document.addEventListener('lunea:cart:added', onAdded);
        document.addEventListener('lunea:cart:error', onError);
        timer = setTimeout(stop, 20000);
      }

      setBusy(on, button) {
        this.busy = on;
        this.classList.toggle('is-busy', on);
        if (button) {
          button.classList.toggle('is-loading', on);
          button.disabled = on;
        }
      }

      reset() {
        this.toggle.checked = false;
        this.variantId = null;
        this.querySelectorAll('[data-routine-variants] [data-variant-id]').forEach(function (button) {
          button.setAttribute('aria-pressed', 'false');
        });
        this.syncSingleVariant();
        this.hideError();
        this.renderState();
      }

      showError(message) {
        if (!this.errorEl) return;
        this.errorEl.textContent = message || '';
        this.errorEl.hidden = false;
      }

      hideError() {
        if (!this.errorEl) return;
        this.errorEl.textContent = '';
        this.errorEl.hidden = true;
      }
    });
  }

  /* ------------------------------------------------------------------------
     2. Strip in de winkelwagenlade
     ---------------------------------------------------------------------- */
  var SECTION = 'lunea-routine-cart';

  function cartSig(cart) {
    return (cart.items || []).map(function (i) { return i.key + ':' + i.quantity + ','; }).join('');
  }

  var Strip = {
    timer: null,
    lastSig: null,
    loading: false,
    observer: null,
    dirty: false,
    mini: null,

    slot: function () { return document.querySelector('[data-lu-routine-slot]'); },

    init: function () {
      var slot = this.slot();
      if (!slot) return;
      var mini = slot.closest('.js-mini-cart');
      // Op /cart staat de lade verborgen in de DOM (zonder .cardraw): niets doen.
      if (!mini || !mini.classList.contains('cardraw') || isCartPage()) return;
      var el = slot.querySelector('lunea-routine-cart');
      this.lastSig = el ? el.getAttribute('data-sig') : null;
      this.mini = mini;
      this.dirty = false;

      if (this.observer) this.observer.disconnect();
      this.observer = new MutationObserver(this.onMutate.bind(this));
      var list = mini.querySelector('.js-mini-cart-content');
      var count = mini.querySelector('.js-cart-count');
      if (list) this.observer.observe(list, { childList: true, subtree: true });
      if (count) this.observer.observe(count, { childList: true, characterData: true, subtree: true });
      this.observer.observe(mini, { attributes: true, attributeFilter: ['class'] });

      if (el && el.getAttribute('data-deferred') === '1') this.refresh();
    },

    isOpen: function () { return !!(this.mini && this.mini.classList.contains('active')); },

    /* theme.js herbouwt de lijst na elke wijziging (ook één keer bij het laden).
       Staat de lade dicht, dan onthouden we dat alleen; pas bij openen kijken we of de
       winkelwagen echt veranderd is. Zo kost een gewone paginaweergave geen extra verzoek. */
    onMutate: function (records) {
      var opened = records.some(function (r) { return r.type === 'attributes'; }) && this.isOpen();
      var changed = records.some(function (r) { return r.type !== 'attributes'; });
      if (changed) this.dirty = true;
      if (this.dirty && (opened || (changed && this.isOpen()))) this.schedule();
    },

    schedule: function () {
      var self = this;
      clearTimeout(this.timer);
      this.timer = setTimeout(function () { self.dirty = false; self.check(); }, 250);
    },

    check: function () {
      var self = this;
      fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { if (cartSig(cart) !== self.lastSig) self.refresh(); })
        .catch(function () {});
    },

    refresh: function () {
      var self = this;
      if (this.loading) { this.again = true; return Promise.resolve(); }
      this.loading = true;
      return fetch(root() + '?sections=' + SECTION, { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var html = data && data[SECTION];
          var slot = self.slot();
          if (typeof html !== 'string' || !slot) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('lunea-routine-cart');
          if (!fresh) return;
          slot.innerHTML = '';
          slot.appendChild(document.importNode(fresh, true));
          self.lastSig = fresh.getAttribute('data-sig');
        })
        .catch(function () {})
        .then(function () {
          self.loading = false;
          if (self.again) { self.again = false; self.check(); }
        });
    }
  };

  if (!customElements.get('lunea-routine-cart')) {
    customElements.define('lunea-routine-cart', class extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        this._ready = true;
        this.busy = false;
        this.onChange = this.onChange.bind(this);
        this.onClick = this.onClick.bind(this);
        this.addEventListener('change', this.onChange);
        this.addEventListener('click', this.onClick);
      }

      disconnectedCallback() {
        if (!this._ready) return;
        this.removeEventListener('change', this.onChange);
        this.removeEventListener('click', this.onClick);
        this._ready = false;
      }

      /* De lade behandelt change-events als aantal-wijziging: niet laten doorgaan. */
      onChange(event) {
        event.stopPropagation();
        this.hideError();
        var select = event.target.closest('select[data-routine-variant]');
        if (!select) return;
        var option = select.selectedOptions ? select.selectedOptions[0] : null;
        var chosen = option && option.value;
        var price = this.querySelector('[data-routine-price]');
        if (price) {
          if (!price.hasAttribute('data-default')) price.setAttribute('data-default', price.textContent);
          price.textContent = chosen ? option.getAttribute('data-price') : price.getAttribute('data-default');
        }
        var save = this.querySelector('[data-routine-save]');
        if (save) {
          if (!save.hasAttribute('data-default')) save.setAttribute('data-default', save.textContent);
          save.textContent = chosen
            ? (save.getAttribute('data-template') || '').replace('[amount]', option.getAttribute('data-save'))
            : save.getAttribute('data-default');
        }
      }

      onClick(event) {
        var button = event.target.closest('[data-routine-add]');
        if (!button) return;
        event.preventDefault();
        this.add(button);
      }

      add(button) {
        if (this.busy) return;
        var self = this;
        // Vóór button.disabled lezen: een uitgeschakelde knop verliest meteen de focus.
        var hadFocus = this.contains(document.activeElement);
        var input = this.querySelector('[data-routine-variant]');
        var variantId = input ? input.value : '';
        if (!variantId) {
          this.showError(this.dataset.choose);
          if (input && input.focus) input.focus();
          return;
        }
        this.busy = true;
        this.classList.add('is-busy');
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');

        function keepFocus() {
          // De strip verdwijnt na het toevoegen; zet de focus op een vaste plek in de lade.
          if (!hadFocus || self.isConnected) return;
          var target = document.querySelector('.js-mini-cart .js-cart-btn-checkout') || document.querySelector('.js-mini-cart .close');
          if (target && target.focus) target.focus();
        }
        function release() {
          self.busy = false;
          self.classList.remove('is-busy');
          button.disabled = false;
          button.removeAttribute('aria-busy');
        }

        postJSON('cart/add.js', { items: [{ id: Number(variantId), quantity: 1 }] })
          .then(function () {
            if (isCartPage()) { window.location.reload(); return; }
            // Lade verversen zoals na elke toevoeging; daarna de strip zelf (die verdwijnt,
            // want nu zit er een product uit groep B in de winkelwagen).
            return Promise.resolve(refreshDrawer())
              .catch(function () {})
              .then(function () { return Strip.refresh(); })
              .then(function () { if (self.isConnected) release(); else keepFocus(); });
          }, function (error) {
            release();
            self.showError((error && error.message) || self.dataset.error);
          });
      }

      showError(message) {
        var el = this.querySelector('[data-routine-error]');
        if (!el) return;
        el.textContent = message || '';
        el.hidden = false;
      }

      hideError() {
        var el = this.querySelector('[data-routine-error]');
        if (!el) return;
        el.textContent = '';
        el.hidden = true;
      }
    });
  }

  if (!window.__luneaRoutineStrip) {
    window.__luneaRoutineStrip = true;
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { Strip.init(); });
    else Strip.init();
    // Theme editor: de header (met de lade) kan opnieuw laden.
    document.addEventListener('shopify:section:load', function () { Strip.init(); });
  }
})();
